import React,{Fragment} from 'react';
import _ from 'lodash';
import styled from 'styled-components';
import {Formik } from 'formik';
import {compose} from 'redux';
import {
  Grid,
  Divider,
  Button,
} from '@material-ui/core';
import { connect } from "react-redux";
import {UnstyledDateField} from 'components/Global/Fields/Date';
import {AutoCompleteInput, DecimalInput} from 'components/Global/FormikMaterial';
import SecondaryButton from 'components/Global/Buttons/SecondaryButton';
import PrimaryButton from 'components/Global/Buttons/PrimaryButton';
import moment from 'moment';

const BlueBorderBox = styled.div`  
  padding: 20px 6px;
`
const AlteredGrid = styled(Grid)`
  &&&& {
    margin-left:10px;
    margin-bottom: 10px;
  } 
`
const LateralLabelGrid = styled(Grid)`
  && {
    margin-top:18px;
  }
`
const LateralLabel = styled.span`
  & {
    font-weight:bold;
    padding-right:8px;
  }
`
const CalculateButtonWrapper = styled(Grid)`
  && {
    margin-top: 14px;
  }
`
const InputSpacer = styled.div`
  width:32px;
`
const DateFieldWrapper = styled.div`
&& {
  margin-top:16px;
}
&& input {
  font-size:17px;
}
 & div:first-child {
   width: 170px;
 }
 & label {
  font-size:17px;
}
 &&&&& div div::before {
   border-bottom: 1px solid #2196F3;
 }
`;

const MARKET_RATE = 1;
const PARALLEL_SHIFT = 2;
const STANDARD_DEVIATION = 3;
class QuoteAnalysis extends React.Component {
  marketEnvs = [
    {
      id: MARKET_RATE,
      name: 'Market Expectations'
    },
    {
      id: PARALLEL_SHIFT,
      name: 'Parallel Shift'
    },
    {
      id: STANDARD_DEVIATION,
      name: 'Standard Deviation'
    }
  ];

  calculate = (values) => {     
    if(values.marketEnvironment === 1){
      values.parallelShiftAmount = '';
      values.standardDeviationAmount = '';
    } else if(values.marketEnvironment === 2){
      values.standardDeviationAmount = '';
    } else if(values.marketEnvironment === 3){
      values.parallelShiftAmount = '';
    }
    this.props.calculate(values, false, true);
  }

  render(){
    
    return (
      <BlueBorderBox>        
        <Formik 
          initialValues={this.props.initialValues}
          validateOnChange={false}
          validate={values => {                
            let errors ={}
            return errors;
          }}
          onSubmit={(values,{setSubmitting}) => {  
            this.calculate(values)
            setSubmitting(false);
          }}
          render={({values,errors,status,touched, isSubmitting,handleChange, handleBlur,handleSubmit}) => (                  
              <AlteredGrid container direction="row" alignItems="center"  spacing={8}>
                <LateralLabelGrid item>
                  <LateralLabel>Market Environment</LateralLabel>
                </LateralLabelGrid>
                <Grid item xs={2}>                
                  <AutoCompleteInput                       
                    label="Market Environment" 
                    fieldName="marketEnvironment"
                    selectValue="id"
                    selectName="name"
                    hideLabel={true}
                    options={this.marketEnvs}>                      
                  </AutoCompleteInput>
                </Grid>
                {this.renderAdditionalRates(values)}                    
                <InputSpacer/>
                <LateralLabelGrid item>
                  <LateralLabel>Exit Date</LateralLabel>
                </LateralLabelGrid>
                <Grid item xs={3}>
                  <DateFieldWrapper>
                    <UnstyledDateField                         
                    name="exitDate"
                    value={values.exitDate}/>
                  </DateFieldWrapper>
                </Grid>
                <CalculateButtonWrapper item >
                  <PrimaryButton onClick={handleSubmit}>calculate</PrimaryButton>
                </CalculateButtonWrapper>
              </AlteredGrid>              
           )}/>
          
       
      </BlueBorderBox>
    )
  }

  renderAdditionalRates = (values) => {
    const selectedEnv = _.get(values, 'marketEnvironment' );
    if(selectedEnv === MARKET_RATE)
      return null;
    else if(selectedEnv === PARALLEL_SHIFT){
      return (
        <Grid item xs={2}>
           <DecimalInput
              fullWidth
              decimalScale={2}
              label="Parallel Shift Amount (bp)"
              fieldName='parallelShiftAmount'              
              >
            </DecimalInput>
        </Grid>
      )
    } else if(selectedEnv === STANDARD_DEVIATION){
      return (
        <Grid item xs={2}>
           <DecimalInput
              fullWidth
              decimalScale={2}
              label="Standard Deviations"
              fieldName='standardDeviationAmount'              
              >
            </DecimalInput>
        </Grid>
      )
    }
  }

}


export default QuoteAnalysis;
